exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.contextmenu-submenu-fade-enter-active,\n.contextmenu-submenu-fade-leave-active {\n  -webkit-transition: opacity 0.1s;\n  transition: opacity 0.1s;\n}\n.contextmenu-submenu-fade-enter,\n.contextmenu-submenu-fade-leave-to {\n  opacity: 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoaders=1?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2c123d7f","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=1!(webpack)-px-to-rem?{"basePx":75,"min":1}!./~/vue-contextmenujs/src/components/Submenu.vue
// module id = 307
// module chunks = 32